import React, { Component } from 'react';

import PropTypes from 'prop-types';

import MultiSelect from '../../../misc/Multiselect';
import TableDataCell from './TableDataCell';

const getTextColor = (bgColor) => {
  if (!bgColor) return '#000'; // Default to black if no background color

  // Convert hex to RGB
  const r = parseInt(bgColor.substring(1, 3), 16);
  const g = parseInt(bgColor.substring(3, 5), 16);
  const b = parseInt(bgColor.substring(5, 7), 16);

  // Calculate luminance
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  // Return white for dark backgrounds, black for light backgrounds
  return luminance > 150 ? '#000' : '#FFF';
};

class TableFieldMultiSelectCell extends Component {
  static propTypes = {
    id: PropTypes.string,
    disabled: PropTypes.bool,
    focused: PropTypes.bool,
    rowId: PropTypes.string,
    columnId: PropTypes.string,
    cellKey: PropTypes.string,
    value: PropTypes.array,
    multi: PropTypes.bool,
    options: PropTypes.array,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    primaryColor: PropTypes.string,
    fontSize: PropTypes.number,
    fontColor: PropTypes.string,
    fontStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    textAlign: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    textOverflow: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.number,
    padding: PropTypes.number,
    width: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      openPopoverFromParent: false,
    };
  }

  getFormattedOptions = () => {
    const { options } = this.props;
    return options
      .filter((opt) => !opt.deleted)
      .map((opt) => ({
        value: opt._id,
        label: opt.value,
        backgroundColor: opt.styles?.backgroundColor || '#f0f0f0',
      }));
  };

  handleChange = (selectedOptions) => {
    const { rowId, columnId, onChange } = this.props;
    const values = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
    if (onChange) {
      onChange(rowId, columnId, values);
    }
  };

  handleFocus = (e) => {

    const { rowId, columnId, columnIdentifier, columnType, onFocus } = this.props;

    if (onFocus) {
      onFocus(rowId, columnId, columnIdentifier, columnType, { blur: () => { e.target.blur(); } });
    }

  };

  handleBlur = () => {
    const { rowId, columnId, columnIdentifier, onBlur, value } = this.props;

    if (onBlur) onBlur(rowId, columnId, columnIdentifier, value);
  };

  render() {

    const {
      id,
      disabled,
      focused,
      rowId,
      columnId,
      columnIdentifier,
      columnType,
      cellKey,
      value,
      multi,
      primaryColor,
      fontSize,
      fontColor,
      fontStyle,
      fontWeight,
      textAlign,
      textTransform,
      textDecoration,
      textOverflow,
      borderColor,
      borderWidth,
      padding,
      width,
      backgroundColor,
      onFocus,
      invalid,
    } = this.props;

    const { openPopoverFromParent } = this.state;

    const formattedOptions = this.getFormattedOptions();
    const selectedValues = formattedOptions.filter((opt) => value?.includes(opt.value));

    return focused && !disabled ? (
      <TableDataCell
        key={cellKey}
        data-testid={`${id}-${rowId}-${columnId}-multiselection-cell`}
        {...{
          focused,
          width,
          padding: 0,
          borderColor,
          borderWidth,
          primaryColor,
          backgroundColor,
        }}
      >
        <MultiSelect
          multiple
          allowMultiple={multi !== false}
          options={formattedOptions}
          value={selectedValues}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          openPopoverFromParent={openPopoverFromParent}
          clearParentPopoverState={() => {
            this.setState({ openPopoverFromParent: false });
          }}
        />
      </TableDataCell>
    ) : (
      <TableDataCell
        key={cellKey}
        disabled={disabled}
        data-testid={`${id}-${rowId}-${columnId}-selection-cell`}
        onClick={() => {
          if (!disabled && !focused && onFocus) {

            onFocus(rowId, columnId, columnIdentifier, columnType, { blur: () => { this.handleBlur(); } });

            /**
             * Logic below ensures that the popover is opened when user clicks on a table multiSelect cell
             */
            this.setState({ openPopoverFromParent: !openPopoverFromParent });

          }
        }}

        width={width}
        fontSize={fontSize}
        fontColor={fontColor}
        fontStyle={fontStyle}
        fontWeight={fontWeight}
        textAlign={textAlign}
        textTransform={textTransform}
        textDecoration={textDecoration}
        textOverflow={textOverflow}
        borderColor={borderColor}
        borderWidth={borderWidth}
        padding={padding}
        primaryColor={primaryColor}
        backgroundColor={backgroundColor}
        invalid={invalid}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {selectedValues.map((opt) => (
            <span
              key={opt.value}
              style={{
                backgroundColor: opt.backgroundColor,
                borderRadius: '12px',
                padding: '4px 8px',
                margin: '4px',
                display: 'inline-block',
                color: getTextColor(opt.backgroundColor),
              }}
            >
              {opt.label}
            </span>
          ))}
        </div>
      </TableDataCell>
    );
  }
}

export default TableFieldMultiSelectCell;
